import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { map } from "lodash";
import { brandImages } from "../../../../theme/brandAssets";

export const MobileSideBar = (props) => {
  const { content, onToggleSideBar, isOpen } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const renderDrawerContent = () => {
    return (
      <List sx={{ pt: 2.5 }}>
        {map(content.top, (content) => {
          const isActive = location.pathname.startsWith(content.link);

          if (!content.isShow) return;

          return (
            <ListItem
              key={content.id}
              {...content.mobileProps}
              sx={{
                backgroundColor: isActive ? "var(--color-primary)" : "#F2F2F3",
                borderRadius: "8px",
                color: isActive ? "#FFFFFF" : "#839BB0",
                height: "3rem",
                my: 1,
                "& .MuiListItemIcon-root": {
                  color: isActive ? "#FFFFFF" : "#839BB0",
                },
                ...content.mobileProps?.sx,
              }}
            >
              <ListItemButton
                onClick={() => {
                  navigate(content.link);
                  onToggleSideBar(false);
                }}
                disableRipple
              >
                <ListItemIcon style={{ minWidth: "3.5rem" }}>
                  <content.Icon
                    style={{
                      width: 29,
                      height: 29,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={content.title}
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: 600,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    );
  };
  return (
    <Drawer
      open={isOpen}
      onClose={() => onToggleSideBar(false)}
      PaperProps={{
        sx: {
          backgroundColor: "#F2F2F3",
          width: "70vw",
          maxWidth: 280,
        },
      }}
    >
      <Stack
        py={3}
        justifyContent={"space-between"}
        alignItems={"center"}
        height={"100%"}
        width={"100%"}
      >
        <Stack alignItems={"center"}>
          <img
            className="brand-logo-img"
            src={brandImages.wordmarkOnLight}
            alt="Kynzo"
            style={{ maxWidth: 180 }}
          />
          {renderDrawerContent()}
        </Stack>
        <List>
          {map(content.bottom, (content) => {
            if (!content.isShow) return;
            return (
              <ListItem
                key={content.id}
                sx={{
                  borderRadius: "8px",
                  color: "#839BB0",
                  height: "3rem",
                }}
              >
                <ListItemButton
                  onClick={() => {
                    content.onClick();
                    onToggleSideBar(false);
                  }}
                  {...content.mobileProps}
                  disableRipple
                >
                  <ListItemIcon style={{ minWidth: "3.5rem" }}>
                    <content.Icon
                      style={{
                        width: 29,
                        height: 29,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={content.title}
                    primaryTypographyProps={{
                      sx: {
                        fontWeight: 600,
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Stack>
    </Drawer>
  );
};
